import { AnyAction, EnhancedStore, configureStore } from '@reduxjs/toolkit';
import throttle from 'lodash/throttle';
import { savePrefrences, saveState } from '~store/utils';
import { AppState, stateReducer } from './modules';
import { ThunkMiddlewareFor } from '@reduxjs/toolkit/dist/getDefaultMiddleware';

export type Store = EnhancedStore<
  AppState,
  AnyAction,
  [ThunkMiddlewareFor<AppState>]
>;

let store: Store;

export const getStore = () => {
  if (!store) {
    store = configureStore({
      reducer: stateReducer,
    });

    const persist = ({
      ignorePreferences = false,
    }: Partial<{ ignorePreferences: boolean }> = {}) => {
      const {
        root: { activeTab, tabs, recent },
        roles,
        debugger: debuggerState,
        webforms,
        sharedCSS,
        settings: { session },
        tasks
      } = store.getState();

      if (!ignorePreferences) {
        savePrefrences({
          ...session,
        });
      }

      saveState({
        tabs,
        activeTab,
        recent,
        roles,
        debugger: debuggerState,
        webforms,
        sharedCSS,
        tasks
      });
    };

    store.subscribe(throttle(persist, 1000));

    window.addEventListener('beforeunload', () => {
      persist({
        ignorePreferences: true,
      });
    });
  }

  return store;
};

export type AppDispatch = typeof store.dispatch;
